import { faAdjust } from '@fortawesome/pro-light-svg-icons/faAdjust';
import { faAlignCenter } from '@fortawesome/pro-light-svg-icons/faAlignCenter';
import { faAlignLeft } from '@fortawesome/pro-light-svg-icons/faAlignLeft';
import { faAlignRight } from '@fortawesome/pro-light-svg-icons/faAlignRight';
import { faAnalytics } from '@fortawesome/pro-light-svg-icons/faAnalytics';
import { faArrowCircleRight } from '@fortawesome/pro-light-svg-icons/faArrowCircleRight';
import { faArrowSquareLeft } from '@fortawesome/pro-light-svg-icons/faArrowSquareLeft';
import { faArrowToRight } from '@fortawesome/pro-light-svg-icons/faArrowToRight';
import { faArrowTurnDownRight } from '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import { faAsterisk } from '@fortawesome/pro-light-svg-icons/faAsterisk';
import { faAt } from '@fortawesome/pro-light-svg-icons/faAt';
import { faBan } from '@fortawesome/pro-light-svg-icons/faBan';
import '@fortawesome/pro-light-svg-icons/faBars';
import { faBolt } from '@fortawesome/pro-light-svg-icons/faBolt';
import { faBell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faBezierCurve } from '@fortawesome/pro-light-svg-icons/faBezierCurve';
import { faBinaryLock } from '@fortawesome/pro-light-svg-icons/faBinaryLock';
import { faBold } from '@fortawesome/pro-light-svg-icons/faBold';
import { faBook } from '@fortawesome/pro-light-svg-icons/faBook';
import { faBookOpen } from '@fortawesome/pro-light-svg-icons/faBookOpen';
import { faBookReader } from '@fortawesome/pro-light-svg-icons/faBookReader';
import { faBookmark } from '@fortawesome/pro-light-svg-icons/faBookmark';
import { faBooks } from '@fortawesome/pro-light-svg-icons/faBooks';
import { faBoxingGlove } from '@fortawesome/pro-light-svg-icons/faBoxingGlove';
import { faBracketsCurly } from '@fortawesome/pro-light-svg-icons/faBracketsCurly';
import { faBrain } from '@fortawesome/pro-light-svg-icons/faBrain';
import { faBrainCircuit } from '@fortawesome/pro-light-svg-icons/faBrainCircuit';
import { faBrowser } from '@fortawesome/pro-light-svg-icons/faBrowser';
import { faBuildings } from '@fortawesome/pro-light-svg-icons/faBuildings';
import { faBullhorn } from '@fortawesome/pro-light-svg-icons/faBullhorn';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay';
import { faCalendarEdit } from '@fortawesome/pro-light-svg-icons/faCalendarEdit';
import { faChalkboardTeacher } from '@fortawesome/pro-light-svg-icons/faChalkboardTeacher';
import { faChartBar } from '@fortawesome/pro-light-svg-icons/faChartBar';
import { faChartColumn } from '@fortawesome/pro-light-svg-icons/faChartColumn';
import { faChartMixed } from '@fortawesome/pro-light-svg-icons/faChartMixed';
import { faChartNetwork } from '@fortawesome/pro-light-svg-icons/faChartNetwork';
import { faChartScatter3d } from '@fortawesome/pro-light-svg-icons/faChartScatter3d';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faChevronDoubleUp } from '@fortawesome/pro-light-svg-icons/faChevronDoubleUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faCircle } from '@fortawesome/pro-light-svg-icons/faCircle';
import { faCircleChevronDown } from '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import { faCircleChevronUp } from '@fortawesome/pro-light-svg-icons/faCircleChevronUp';
import { faCircleDollar } from '@fortawesome/pro-light-svg-icons/faCircleDollar';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { faCircleMinus } from '@fortawesome/pro-light-svg-icons/faCircleMinus';
import { faCirclePlus } from '@fortawesome/pro-light-svg-icons/faCirclePlus';
import { faCircleUser } from '@fortawesome/pro-light-svg-icons/faCircleUser';
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons/faCircleXmark';
import { faClipboard } from '@fortawesome/pro-light-svg-icons/faClipboard';
import { faClipboardListCheck } from '@fortawesome/pro-light-svg-icons/faClipboardListCheck';
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faClone } from '@fortawesome/pro-light-svg-icons/faClone';
import '@fortawesome/pro-light-svg-icons/faCloud';
import { faCloudDownload } from '@fortawesome/pro-light-svg-icons/faCloudDownload';
import { faCode } from '@fortawesome/pro-light-svg-icons/faCode';
import { faCodeBranch } from '@fortawesome/pro-light-svg-icons/faCodeBranch';
import { faCodeMerge } from '@fortawesome/pro-light-svg-icons/faCodeMerge';
import { faCogs } from '@fortawesome/pro-light-svg-icons/faCogs';
import { faCommentAltLines } from '@fortawesome/pro-light-svg-icons/faCommentAltLines';
import { faCommentLines } from '@fortawesome/pro-light-svg-icons/faCommentLines';
import { faCommentsAlt } from '@fortawesome/pro-light-svg-icons/faCommentsAlt';
import { faCompressAlt } from '@fortawesome/pro-light-svg-icons/faCompressAlt';
import { faComputer } from '@fortawesome/pro-light-svg-icons/faComputer';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard';
import { faCube } from '@fortawesome/pro-light-svg-icons/faCube';
import { faCubes } from '@fortawesome/pro-light-svg-icons/faCubes';
import { faDatabase } from '@fortawesome/pro-light-svg-icons/faDatabase';
import { faDiagramSubtask } from '@fortawesome/pro-light-svg-icons/faDiagramSubtask';
import { faDice } from '@fortawesome/pro-light-svg-icons/faDice';
import { faDollarSign } from '@fortawesome/pro-light-svg-icons/faDollarSign';
import { faDownLeftAndUpRightToCenter } from '@fortawesome/pro-light-svg-icons/faDownLeftAndUpRightToCenter';
import { faEdit } from '@fortawesome/pro-light-svg-icons/faEdit';
import { faEllipsisH } from '@fortawesome/pro-light-svg-icons/faEllipsisH';
import { faEllipsisV } from '@fortawesome/pro-light-svg-icons/faEllipsisV';
import { faEnvelopeOpenText } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash';
import { faEraser } from '@fortawesome/pro-light-svg-icons/faEraser';
import { faExchangeAlt } from '@fortawesome/pro-light-svg-icons/faExchangeAlt';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faExpandAlt } from '@fortawesome/pro-light-svg-icons/faExpandAlt';
import { faExpandWide } from '@fortawesome/pro-light-svg-icons/faExpandWide';
import { faFile } from '@fortawesome/pro-light-svg-icons/faFile';
import { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt';
import { faFileAudio } from '@fortawesome/pro-light-svg-icons/faFileAudio';
import { faFileChartLine } from '@fortawesome/pro-light-svg-icons/faFileChartLine';
import { faFileCode } from '@fortawesome/pro-light-svg-icons/faFileCode';
import { faFileCsv } from '@fortawesome/pro-light-svg-icons/faFileCsv';
import { faFileExcel } from '@fortawesome/pro-light-svg-icons/faFileExcel';
import { faFileExport } from '@fortawesome/pro-light-svg-icons/faFileExport';
import { faFileImport } from '@fortawesome/pro-light-svg-icons/faFileImport';
import { faFileInvoice } from '@fortawesome/pro-light-svg-icons/faFileInvoice';
import { faFileInvoiceDollar } from '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf';
import { faFilePowerpoint } from '@fortawesome/pro-light-svg-icons/faFilePowerpoint';
import { faFileSignature } from '@fortawesome/pro-light-svg-icons/faFileSignature';
import { faFileSpreadsheet } from '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';
import { faFileUpload } from '@fortawesome/pro-light-svg-icons/faFileUpload';
import { faFileVector } from '@fortawesome/pro-light-svg-icons/faFileVector';
import { faFileVideo } from '@fortawesome/pro-light-svg-icons/faFileVideo';
import { faFileWord } from '@fortawesome/pro-light-svg-icons/faFileWord';
import { faFiles } from '@fortawesome/pro-light-svg-icons/faFiles';
import { faFilter } from '@fortawesome/pro-light-svg-icons/faFilter';
import { faFolder } from '@fortawesome/pro-light-svg-icons/faFolder';
import { faFont } from '@fortawesome/pro-light-svg-icons/faFont';
import { faGameBoardAlt } from '@fortawesome/pro-light-svg-icons/faGameBoardAlt';
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe';
import { faGlobeEurope } from '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import { faGlobePointer } from '@fortawesome/pro-light-svg-icons/faGlobePointer';
import { faGripLinesVertical } from '@fortawesome/pro-light-svg-icons/faGripLinesVertical';
import { faGripVertical } from '@fortawesome/pro-light-svg-icons/faGripVertical';
import { faHammer } from '@fortawesome/pro-light-svg-icons/faHammer';
import { faH1 } from '@fortawesome/pro-light-svg-icons/faH1';
import { faH2 } from '@fortawesome/pro-light-svg-icons/faH2';
import { faHandshake } from '@fortawesome/pro-light-svg-icons/faHandshake';
import { faHardDrive } from '@fortawesome/pro-light-svg-icons/faHardDrive';
import { faHashtag } from '@fortawesome/pro-light-svg-icons/faHashtag';
import { faHeadSideBrain } from '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import { faHeadset } from '@fortawesome/pro-light-svg-icons/faHeadset';
import { faHelmetBattle } from '@fortawesome/pro-light-svg-icons/faHelmetBattle';
import { faHexagonPlus } from '@fortawesome/pro-light-svg-icons/faHexagonPlus';
import { faHighlighter } from '@fortawesome/pro-light-svg-icons/faHighlighter';
import { faHistory } from '@fortawesome/pro-light-svg-icons/faHistory';
import { faHomeAlt } from '@fortawesome/pro-light-svg-icons/faHomeAlt';
import { faHouseLock } from '@fortawesome/pro-light-svg-icons/faHouseLock';
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage';
import { faImageLandscape } from '@fortawesome/pro-light-svg-icons/faImageLandscape';
import { faImagePolaroid } from '@fortawesome/pro-light-svg-icons/faImagePolaroid';
import { faImages } from '@fortawesome/pro-light-svg-icons/faImages';
import { faInbox } from '@fortawesome/pro-light-svg-icons/faInbox';
import { faIndent } from '@fortawesome/pro-light-svg-icons/faIndent';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faInputText } from '@fortawesome/pro-light-svg-icons/faInputText';
import { faItalic } from '@fortawesome/pro-light-svg-icons/faItalic';
import { faKeyboard } from '@fortawesome/pro-light-svg-icons/faKeyboard';
import { faKitchenSet } from '@fortawesome/pro-light-svg-icons/faKitchenSet';
import { faLanguage } from '@fortawesome/pro-light-svg-icons/faLanguage';
import { faLaptopCode } from '@fortawesome/pro-light-svg-icons/faLaptopCode';
import { faLayerGroup } from '@fortawesome/pro-light-svg-icons/faLayerGroup';
import { faLightbulb } from '@fortawesome/pro-light-svg-icons/faLightbulb';
import { faLightbulbExclamation } from '@fortawesome/pro-light-svg-icons/faLightbulbExclamation';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { faListCheck } from '@fortawesome/pro-light-svg-icons/faListCheck';
import { faListOl } from '@fortawesome/pro-light-svg-icons/faListOl';
import { faListUl } from '@fortawesome/pro-light-svg-icons/faListUl';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faLockOpen } from '@fortawesome/pro-light-svg-icons/faLockOpen';
import { faMagic } from '@fortawesome/pro-light-svg-icons/faMagic';
import { faMagicWandSparkles } from '@fortawesome/pro-light-svg-icons/faMagicWandSparkles';
import { faMessageBot } from '@fortawesome/pro-light-svg-icons/faMessageBot';
import { faMessageDots } from '@fortawesome/pro-light-svg-icons/faMessageDots';
import { faMessageSms } from '@fortawesome/pro-light-svg-icons/faMessageSms';
import { faMeteor } from '@fortawesome/pro-light-svg-icons/faMeteor';
import { faMicrophone } from '@fortawesome/pro-light-svg-icons/faMicrophone';
import { faMicrophoneSlash } from '@fortawesome/pro-light-svg-icons/faMicrophoneSlash';
import { faMicroscope } from '@fortawesome/pro-light-svg-icons/faMicroscope';
import { faMoneyCheckAlt } from '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt';
import { faNetworkWired } from '@fortawesome/pro-light-svg-icons/faNetworkWired';
import { faPageBreak } from '@fortawesome/pro-light-svg-icons/faPageBreak';
import { faPalette } from '@fortawesome/pro-light-svg-icons/faPalette';
import { faPaperPlaneTop } from '@fortawesome/pro-light-svg-icons/faPaperPlaneTop';
import { faPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip';
import { faPlay } from '@fortawesome/pro-light-svg-icons/faPlay';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { faPeopleArrows } from '@fortawesome/pro-light-svg-icons/faPeopleArrows';
import { faPersonFairy } from '@fortawesome/pro-light-svg-icons/faPersonFairy';
import { faPlanetMoon } from '@fortawesome/pro-light-svg-icons/faPlanetMoon';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import { faPowerOff } from '@fortawesome/pro-light-svg-icons/faPowerOff';
import { faPresentationScreen } from '@fortawesome/pro-light-svg-icons/faPresentationScreen';
import { faPrintMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faPrintMagnifyingGlass';
import { faProjectDiagram } from '@fortawesome/pro-light-svg-icons/faProjectDiagram';
import { faQuestion } from '@fortawesome/pro-light-svg-icons/faQuestion';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import { faQuoteLeft } from '@fortawesome/pro-light-svg-icons/faQuoteLeft';
import { faRandom } from '@fortawesome/pro-light-svg-icons/faRandom';
import { faRectangleXmark } from '@fortawesome/pro-light-svg-icons/faRectangleXmark';
import { faRedo } from '@fortawesome/pro-light-svg-icons/faRedo';
import { faReply } from '@fortawesome/pro-light-svg-icons/faReply';
import { faRobot } from '@fortawesome/pro-light-svg-icons/faRobot';
import { faRocketLaunch } from '@fortawesome/pro-light-svg-icons/faRocketLaunch';
import { faSatelliteDish } from '@fortawesome/pro-light-svg-icons/faSatelliteDish';
import { faScaleBalanced } from '@fortawesome/pro-light-svg-icons/faScaleBalanced';
import { faScannerTouchscreen } from '@fortawesome/pro-light-svg-icons/faScannerTouchscreen';
import '@fortawesome/pro-light-svg-icons/faScrewdriverWrench';
import { faScrubber } from '@fortawesome/pro-light-svg-icons/faScrubber';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faSearchMinus } from '@fortawesome/pro-light-svg-icons/faSearchMinus';
import { faSearchPlus } from '@fortawesome/pro-light-svg-icons/faSearchPlus';
import { faServer } from '@fortawesome/pro-light-svg-icons/faServer';
import { faShareAlt } from '@fortawesome/pro-light-svg-icons/faShareAlt';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faShieldHalved } from '@fortawesome/pro-light-svg-icons/faShieldHalved';
import { faSidebar } from '@fortawesome/pro-light-svg-icons/faSidebar';
import { faSignOut } from '@fortawesome/pro-light-svg-icons/faSignOut';
import { faSitemap } from '@fortawesome/pro-light-svg-icons/faSitemap';
import { faSlidersH } from '@fortawesome/pro-light-svg-icons/faSlidersH';
import { faSlidersV } from '@fortawesome/pro-light-svg-icons/faSlidersV';
import { faSlidersVSquare } from '@fortawesome/pro-light-svg-icons/faSlidersVSquare';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { faSpinner } from '@fortawesome/pro-light-svg-icons/faSpinner';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faSquareCheck } from '@fortawesome/pro-light-svg-icons/faSquareCheck';
import { faSquareRss } from '@fortawesome/pro-light-svg-icons/faSquareRss';
import { faStar } from '@fortawesome/pro-light-svg-icons/faStar';
import { faStopCircle } from '@fortawesome/pro-light-svg-icons/faStopCircle';
import { faStream } from '@fortawesome/pro-light-svg-icons/faStream';
import { faStrikethrough } from '@fortawesome/pro-light-svg-icons/faStrikethrough';
import { faSwap } from '@fortawesome/pro-light-svg-icons/faSwap';
import { faSwords } from '@fortawesome/pro-light-svg-icons/faSwords';
import { faSwordsLaser } from '@fortawesome/pro-light-svg-icons/faSwordsLaser';
import { faSync } from '@fortawesome/pro-light-svg-icons/faSync';
import { faTableCells } from '@fortawesome/pro-light-svg-icons/faTableCells';
import { faTableList } from '@fortawesome/pro-light-svg-icons/faTableList';
import { faTag } from '@fortawesome/pro-light-svg-icons/faTag';
import { faTerminal } from '@fortawesome/pro-light-svg-icons/faTerminal';
import { faThoughtBubble } from '@fortawesome/pro-light-svg-icons/faThoughtBubble';
import { faThumbsDown } from '@fortawesome/pro-light-svg-icons/faThumbsDown';
import { faThumbsUp } from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import { faThumbtack } from '@fortawesome/pro-light-svg-icons/faThumbtack';
import { faTimer } from '@fortawesome/pro-light-svg-icons/faTimer';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { faTools } from '@fortawesome/pro-light-svg-icons/faTools';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import { faTrophy } from '@fortawesome/pro-light-svg-icons/faTrophy';
import { faTruck } from '@fortawesome/pro-light-svg-icons/faTruck';
import { faTypewriter } from '@fortawesome/pro-light-svg-icons/faTypewriter';
import { faUnderline } from '@fortawesome/pro-light-svg-icons/faUnderline';
import { faUndo } from '@fortawesome/pro-light-svg-icons/faUndo';
import { faUnlink } from '@fortawesome/pro-light-svg-icons/faUnlink';
import { faUnlock } from '@fortawesome/pro-light-svg-icons/faUnlock';
import { faUnlockKeyhole } from '@fortawesome/pro-light-svg-icons/faUnlockKeyhole';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons/faUpRightAndDownLeftFromCenter';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faUserAstronaut } from '@fortawesome/pro-light-svg-icons/faUserAstronaut';
import { faUserBeardBolt } from '@fortawesome/pro-light-svg-icons/faUserBeardBolt';
import { faUserCircle } from '@fortawesome/pro-light-svg-icons/faUserCircle';
import { faUserGear } from '@fortawesome/pro-light-svg-icons/faUserGear';
import { faUserHeadset } from '@fortawesome/pro-light-svg-icons/faUserHeadset';
import { faUserLock } from '@fortawesome/pro-light-svg-icons/faUserLock';
import { faUserNinja } from '@fortawesome/pro-light-svg-icons/faUserNinja';
import { faUserPilotTie } from '@fortawesome/pro-light-svg-icons/faUserPilotTie';
import { faUserRobot } from '@fortawesome/pro-light-svg-icons/faUserRobot';
import { faUserShakespeare } from '@fortawesome/pro-light-svg-icons/faUserShakespeare';
import { faUserShield } from '@fortawesome/pro-light-svg-icons/faUserShield';
import { faUserVisor } from '@fortawesome/pro-light-svg-icons/faUserVisor';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faUsersCog } from '@fortawesome/pro-light-svg-icons/faUsersCog';
import { faVectorPolygon } from '@fortawesome/pro-light-svg-icons/faVectorPolygon';
import { faVial } from '@fortawesome/pro-light-svg-icons/faVial';
import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo';
import { faVideoPlus } from '@fortawesome/pro-light-svg-icons/faVideoPlus';
import { faVolume } from '@fortawesome/pro-light-svg-icons/faVolume';
import { faVolumeSlash } from '@fortawesome/pro-light-svg-icons/faVolumeSlash';
import { faWandMagicSparkles } from '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import { faWandSparkles } from '@fortawesome/pro-light-svg-icons/faWandSparkles';
import { faWaveSquare } from '@fortawesome/pro-light-svg-icons/faWaveSquare';
import { faWhale } from '@fortawesome/pro-light-svg-icons/faWhale';
import { faWifiSlash } from '@fortawesome/pro-light-svg-icons/faWifiSlash';
import { faWindowMaximize } from '@fortawesome/pro-light-svg-icons/faWindowMaximize';
import { faWindowMinimize } from '@fortawesome/pro-light-svg-icons/faWindowMinimize';
import { faWindowRestore } from '@fortawesome/pro-light-svg-icons/faWindowRestore';
import { faWrench } from '@fortawesome/pro-light-svg-icons/faWrench';
import { faXmarkToSlot } from '@fortawesome/pro-light-svg-icons/faXmarkToSlot';
import { faChalkboard } from '@fortawesome/pro-light-svg-icons/faChalkboard';
import { faEarthAmericas } from '@fortawesome/pro-light-svg-icons/faEarthAmericas';
import { faEarthEurope } from '@fortawesome/pro-light-svg-icons/faEarthEurope';
import { faEarthOceania } from '@fortawesome/pro-light-svg-icons/faEarthOceania';
import { faHexagonNodesBolt } from '@fortawesome/pro-light-svg-icons/faHexagonNodesBolt';
import { faWaveformLines } from '@fortawesome/pro-light-svg-icons/faWaveformLines';
import { faPause } from '@fortawesome/pro-light-svg-icons/faPause';
import { faPlayPause } from '@fortawesome/pro-light-svg-icons/faPlayPause';
import { faUserHoodie } from '@fortawesome/pro-light-svg-icons/faUserHoodie';
import '@fortawesome/pro-light-svg-icons/faMemoCircleInfo';
import { faMemoCircleCheck } from '@fortawesome/pro-light-svg-icons/faMemoCircleCheck';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import '@fortawesome/pro-light-svg-icons/faGearCode';
import { faGearComplexCode } from '@fortawesome/pro-light-svg-icons/faGearComplexCode';
import { faRotateExclamation } from '@fortawesome/pro-light-svg-icons/faRotateExclamation';
import { faCommentExclamation } from '@fortawesome/pro-light-svg-icons/faCommentExclamation';
import { faHourglassClock } from '@fortawesome/pro-light-svg-icons/faHourglassClock';
import { faCompassDrafting } from '@fortawesome/pro-light-svg-icons/faCompassDrafting';
import { faHatWizard } from '@fortawesome/pro-light-svg-icons/faHatWizard';
import { faCircleMicrophone } from '@fortawesome/pro-light-svg-icons/faCircleMicrophone';
import { faCirclePause } from '@fortawesome/pro-light-svg-icons/faCirclePause';
import { faNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons/faCalendarDays';
import { faFlaskGear } from '@fortawesome/pro-light-svg-icons/faFlaskGear';
import { faArrowsTurnToDots } from '@fortawesome/pro-light-svg-icons/faArrowsTurnToDots';
import { faBarsStaggered } from '@fortawesome/pro-light-svg-icons/faBarsStaggered';
import { faPlugCirclePlus } from '@fortawesome/pro-light-svg-icons/faPlugCirclePlus';
import { faFilePlusMinus } from '@fortawesome/pro-light-svg-icons/faFilePlusMinus';
import { faDownload } from '@fortawesome/pro-light-svg-icons/faDownload';
import { faDisplayCode } from '@fortawesome/pro-light-svg-icons/faDisplayCode';
import { faWebhook } from '@fortawesome/pro-light-svg-icons/faWebhook';
import { faLaptopMobile } from '@fortawesome/pro-light-svg-icons/faLaptopMobile';

var AppAssets = {
  logo: "appLogo.png?1j5ou2-",
  darkLogo: "appLogoDark.png?1QmeT7S",
  social: {
    google: "googleSocialIconCompressed.png?21tzkLJ",
    facebook: "logo_facebookCompressed.png?3PXGfBq",
    apple: "logoAppleCompressed.png?K8WhQl6",
    create: "logo_createaccount.png?3TZcjMJ",
    simpleCircle: faScrubber
  },
  icons: {
    support: faLaptopMobile,
    webhook: faWebhook,
    tfcode: faDisplayCode,
    agenticInterleaved: faArrowsTurnToDots,
    pause: faCirclePause,
    mcp: faHexagonNodesBolt,
    produs: faEarthAmericas,
    prodeu: faEarthEurope,
    prod: faEarthOceania,
    wizard: faHatWizard,
    prodau: faEarthOceania,
    dev: faEarthOceania,
    canvas: faChalkboard,
    desktop: faComputer,
    windowClose: faRectangleXmark,
    windowMaximise: faWindowMaximize,
    windowMinimise: faWindowMinimize,
    windowRestore: faWindowRestore,
    thoughts: faLightbulb,
    plusCircle: faCirclePlus,
    minus: faCircleMinus,
    tick: faCheck,
    plannerStep: faListCheck,
    vectors: faVectorPolygon,
    save: faDownload,
    route: faSwap,
    reasoning: faThoughtBubble,
    duration: faTimer,
    tools: faKitchenSet,
    build: faHammer,
    noAccess: faXmarkToSlot,
    closeAdv: faXmark,
    internal: faHouseLock,
    external: faGlobe,
    hire: faWandSparkles,
    memory: faHardDrive,
    introspection: faSpinner,
    moderation: faShieldCheck,
    news: faSquareRss,
    internet: faGlobe,
    capabililities: faGearComplexCode,
    deepFileSearch: faFileVector,
    sidebar: faSidebar,
    handOff: faRotateExclamation,
    agentsPlan: faSitemap,
    docx: faFileWord,
    api: faBezierCurve,
    ppt: faFilePowerpoint,
    pptx: faFilePowerpoint,
    csv: faFileCsv,
    xlsx: faFileExcel,
    xlsm: faFileExcel,
    download: faCloudDownload,
    account: faUser,
    magic: faMagic,
    thumbsUp: faThumbsUp,
    thumbsDown: faThumbsDown,
    preference: faAsterisk,
    new: faSparkles,
    summary: faIndent,
    handoff: faRandom,
    skill: faCompassDrafting,
    add_icon: faPlusCircle,
    alignCenter: faAlignCenter,
    alignLeft: faAlignLeft,
    alignRight: faAlignRight,
    arrow_down: faChevronDown,
    arrow_up: faChevronUp,
    arrow_left: faChevronLeft,
    arrow_right: faChevronRight,
    winner: faTrophy,
    boxing: faBoxingGlove,
    round: faDice,
    swords: faSwords,
    simpleCircle: faScrubber,
    back_icon: faChevronLeft,
    blockOption: faGripVertical,
    separator: faGripLinesVertical,
    bold: faBold,
    bookmark: faBookmark,
    centerAlign: faAlignCenter,
    microphone: faMicrophone,
    microphoneSlash: faMicrophoneSlash,
    check: faCheckCircle,
    squareCheck: faSquareCheck,
    squareUncheck: faSquare,
    filter: faFilter,
    clear: faEraser,
    js: faCode,
    java: faCode,
    py: faCode,
    yaml: faCode,
    yml: faCode,
    sql: faCode,
    sh: faCode,
    php: faCode,
    js: faCode,
    ts: faCode,
    csharp: faCode,
    rb: faCode,
    jsx: faCode,
    tsx: faCode,
    scan: faScannerTouchscreen,
    clock: faClock,
    close: faCircleXmark,
    code: faCode,
    convert: faExchangeAlt,
    decision: faRocketLaunch,
    agentFunction: faCodeMerge,
    fork: faCodeBranch,
    editModel: faHexagonNodesBolt,
    acg: faBookReader,
    response: faBracketsCurly,
    charting: faChartBar,
    basePath: faSatelliteDish,
    idea: faLightbulbExclamation,
    delete: faTrash,
    duplicate: faCopy,
    send: faPaperPlaneTop,
    run: faPlay,
    enableAI: faChartNetwork,
    widget: faBrowser,
    events: faInbox,
    file: faFileAlt,
    txt: faFile,
    md: faCode,
    video: faVideoPlus,
    fileVideo: faFileVideo,
    audio: faFileAudio,
    minimise: faWindowMinimize,
    reload: faSync,
    html: faFileCode,
    referral: faPeopleArrows,
    contentCreator: faUserShakespeare,
    planner: faUserPilotTie,
    coder: faUserBeardBolt,
    businessAnalyst: faUserVisor,
    casual: faUserNinja,
    folder: faFolder,
    readMode: faNewspaper,
    days: faCalendarDays,
    record: faCircleMicrophone,
    persona: faUserGear,
    fullscreen: faExpandWide,
    heading1: faH1,
    embeddings: faPageBreak,
    heading2: faH2,
    highlight: faHighlighter,
    history: faHistory,
    home: faHomeAlt,
    import: faFileUpload,
    horizontalOption: faEllipsisH,
    intentSelection: faHeadSideBrain,
    advancedReasoning: faBrainCircuit,
    italic: faItalic,
    answer_icon: faReply,
    keyboardHide: faKeyboard,
    layerGroup: faLayerGroup,
    link: faLink,
    lock: faLock,
    writer: faTypewriter,
    meeting: faCalendarEdit,
    menu: faBarsStaggered,
    issue: faMeteor,
    navigationBack: faChevronLeft,
    quantumChat: faCommentsAlt,
    chatIcon: faCommentAltLines,
    preferences: faScaleBalanced,
    feedback: faCommentExclamation,
    queue: faHourglassClock,
    uoi: faCube,
    navigationTo: faChevronRight,
    ner: faTag,
    NERentity: faRocketLaunch,
    notes: faBookOpen,
    notification: faBell,
    ol: faListOl,
    option: faEllipsisV,
    arrowAlt: faArrowToRight,
    hash: faHashtag,
    paintRoller: faPalette,
    plan: faClipboardListCheck,
    question_icon: faQuestionCircle,
    messaging: faMessageDots,
    sms: faMessageSms,
    email: faAt,
    incognito: faBinaryLock,
    day: faCalendarDay,
    quote: faQuoteLeft,
    redo: faRedo,
    ba: faFileChartLine,
    requirement: faPen,
    risk: faExclamationTriangle,
    search: faSearch,
    settings: faSlidersVSquare,
    slidersV: faSlidersV,
    slidersH: faSlidersH,
    strikethrough: faStrikethrough,
    template: faFileAlt,
    theme_adjust: faAdjust,
    show: faUnlock,
    hide: faLock,
    eye: faEye,
    eyeSlash: faEyeSlash,
    times: faTimes,
    timezone: faGlobeEurope,
    timezoneOnboarding: faPlanetMoon,
    trainAI: faUserRobot,
    ul: faListUl,
    tilesView: faTableCells,
    tableView: faTableList,
    image: faImage,
    uncheck: faCircle,
    underlined: faUnderline,
    undo: faUndo,
    unlink: faUnlink,
    unlock: faLockOpen,
    urlGen: faFileImport,
    verticalOption: faEllipsisV,
    workspace: faGameBoardAlt,
    highPriority: faChevronDoubleUp,
    mediumPriority: faChevronUp,
    lowPriority: faChevronDown,
    orbit: faWandMagicSparkles,
    bolt: faBolt,
    export: faFileExport,
    generateEmail: faEnvelopeOpenText,
    ai: faBrain,
    cogWheel: faWrench,
    pdf: faFilePdf,
    edit: faEdit,
    terminal: faTerminal,
    fontColor: faFont,
    network: faNetworkWired,
    logout: faPowerOff,
    goBack: faArrowSquareLeft,
    parse: faFileSignature,
    share: faShareAlt,
    trainingLog: faStream,
    expandVertically: faExpandAlt,
    collapseVertically: faCompressAlt,
    users: faUsers,
    private: faUserLock,
    usersSettings: faUsersCog,
    userInfo: faUserCircle,
    billing: faCreditCard,
    pin: faThumbtack,
    parser: faLaptopCode,
    admin: faUserShield,
    accessDenied: faBan,
    copy: faClone,
    answerer: faCommentLines,
    signOut: faSignOut,
    info: faInfoCircle,
    progress: faSpinner,
    cost: faDollarSign,
    question: faQuestion,
    enter: faArrowCircleRight,
    plus: faPlus,
    invoice: faFileInvoiceDollar,
    billingDetails: faMoneyCheckAlt,
    trial: faVial,
    data: faDatabase,
    collection: faBooks,
    language: faLanguage,
    networkError: faWifiSlash,
    activeModel: faWaveSquare,
    quickCopy: faClipboard,
    agent: faUserVisor,
    experiment: faVial,
    zoomIn: faSearchPlus,
    zoomOut: faSearchMinus,
    stopGeneration: faStopCircle,
    slidersH: faSlidersH,
    hosting: faServer,
    advanced: faTools,
    dashboard: faAnalytics,
    files: faFiles,
    goTo: faArrowTurnDownRight,
    warning: faTriangleExclamation,
    channels: faMessageBot,
    speakers: faVolume,
    downloadAudio: faFileAudio,
    stopPlaying: faVolumeSlash,
    images: faImages,
    arena: faSwordsLaser,
    newBattle: faHelmetBattle,
    expand: faUpRightAndDownLeftFromCenter,
    collapse: faDownLeftAndUpRightToCenter,
    spreadsheet: faFileSpreadsheet,
    presentation: faPresentationScreen,
    document: faFileInvoice,
    teach: faChalkboardTeacher,
    domain: faLayerGroup,
    subscriptionType: faCircleDollar,
    fairy: faPersonFairy,
    artifacts: faCubes,
    taskAgent: faUserAstronaut,
    assemble: faLayerGroup,
    launch: faRocketLaunch,
    deploy: faSatelliteDish,
    computerUser: faUserHoodie,
    voiceUser: faUserHeadset,
    userEnhanced: faCircleUser,
    web: faGlobePointer,
    art: faPalette,
    chartingAgent: faChartMixed,
    advancedImage: faImageLandscape,
    promptBuffering: faHexagonPlus,
    agentic: faDiagramSubtask,
    deepSearch: faPrintMagnifyingGlass,
    shield: faShieldHalved,
    treeOfThoughts: faDiagramSubtask,
    sales: faHandshake,
    handshake: faHandshake,
    marketing: faBullhorn,
    operations: faCogs,
    customerService: faHeadset,
    research: faMicroscope,
    legal: faScaleBalanced,
    supplyChain: faTruck,
    genericDepartment: faBuildings,
    entities: faInputText,
    project: faProjectDiagram,
    attachment: faPaperclip,
    deep_search: faWhale,
    expandReasoning: faCircleChevronDown,
    collapseReasoning: faCircleChevronUp,
    credentials: faUnlockKeyhole,
    model3d: faChartScatter3d,
    benchmark: faChartColumn,
    human: faUser,
    ollama: faRobot,
    planMode: faPause,
    executeMode: faPlayPause,
    liveMode: faWaveformLines,
    sources: faMemoCircleCheck,
    "planner-auto": faMagicWandSparkles,
    "planner-empty": faCircleExclamation,
    knowledge: faBook,
    functions: faCodeMerge,
    "image-gen": faImagePolaroid,
    "video-gen": faVideo,
    "3d-gen": faCube,
    "no-tools": faTriangleExclamation,
    star: faStar,
    experimentAgent: faFlaskGear,
    consumed: faPlugCirclePlus,
    consumedUoI: faHexagonNodesBolt,
    changeFile: faFilePlusMinus
  }
};

//

export { AppAssets as A };
